export class BaseModelMicroService {
    id: number;
    isActive = true;
}
